import register from '../../../../global/js/registry';
export default register('o-pdf-search-header', () => import(/* webpackMode: "lazy" */ './o-pdf-search-header.controller'));
